import { makeActionCreatorObjParam } from '@trumedianetworks/tmn-core-components/src/util/redux-helpers';
import * as t from './action_types';

const _showSnackbar = makeActionCreatorObjParam(t.OPEN_SNACKBAR, 'snackbarType', 'snackbarMessage');

let snackbarTimer;

export const showSnackbar = (params) => (dispatch) => {
    dispatch(_showSnackbar(params));
    let { snackbarTime = 3000 } = params;
    snackbarTime = Math.min(snackbarTime, 15000);
    window.clearTimeout(snackbarTimer);
    snackbarTimer = window.setTimeout(() => dispatch({ type: t.CLOSE_SNACKBAR }), snackbarTime);
};
